import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  agentPreferenceModal: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    showAgentPreferenceModal: (state) => {
      state.agentPreferenceModal = true;
    },
    hideAgentPreferenceModal: (state) => {
      state.agentPreferenceModal = false;
    },
  },
});

export const { showAgentPreferenceModal, hideAgentPreferenceModal } =
  uiSlice.actions;

export default uiSlice.reducer;
